<script lang="ts" setup>
import { useLink } from "../../composables/useLink.js";
import { injectI18n } from "../../i18n/index.js";
import OnyxVisuallyHidden from "../OnyxVisuallyHidden/OnyxVisuallyHidden.vue";
import type { OnyxRouterLinkProps } from "./types.js";

const props = withDefaults(defineProps<OnyxRouterLinkProps>(), {
  target: "_self",
});

defineSlots<{
  default(): unknown;
}>();

const { t } = injectI18n();
const { navigate, isActive } = useLink();
</script>

<template>
  <a
    :class="[
      'onyx-component',
      'onyx-router-link',
      { 'onyx-router-link--active': isActive(props.href) },
    ]"
    :href="props.href"
    :target="props.target"
    :rel="props.target === '_blank' ? 'noreferrer' : undefined"
    @click="navigate($event, props.href)"
  >
    <slot></slot>

    <OnyxVisuallyHidden v-if="props.target === '_blank'">
      {{ t("link.opensExternally") }}
    </OnyxVisuallyHidden>
  </a>
</template>

<style lang="scss">
@use "../../styles/mixins/layers.scss";

.onyx-router-link {
  @include layers.component() {
    cursor: pointer;

    // reset styles
    outline-offset: inherit;
    text-decoration: inherit;
    color: inherit;
  }
}
</style>
